function countdown(elementName, minutes, seconds) {
  var element, endTime, hours, mins, msLeft, time;
  function twoDigits(n) {
    return n <= 9 ? "0" + n : n;
  }

  function updateTimer() {
    msLeft = endTime - +new Date();
    if (msLeft < 1000) {
      element.innerHTML = "Time is up!";
    } else {
      time = new Date(msLeft);
      hours = time.getUTCHours();
      mins = time.getUTCMinutes();
      element.innerHTML =
        (hours ? hours + ":" + twoDigits(mins) : mins) +
        ":" +
        twoDigits(time.getUTCSeconds());
      setTimeout(updateTimer, time.getUTCMilliseconds() + 500);
    }
  }

  element = document.getElementById(elementName);
  endTime = +new Date() + 1000 * (60 * minutes + seconds) + 500;
  updateTimer();
}

$("document").ready(function () {
  $("[data-modal]").on("click", function () {
    var modalID = $(this).attr("data-modal");
    $(".custom-modal#" + modalID).addClass("show");
  });

  $(".custom-modal__close").on("click", function () {
    $(this).parents(".custom-modal").removeClass("show");
  });
});

jQuery(".order--product").click(function (e) {
  e.preventDefault();
  let productID = jQuery(".order--product-ID").val();
  if (productID) {
    $.ajax({
      type: "POST",
      url: window.Shopify.routes.root + "cart/add.js",
      dataType: "json",
      data: { id: productID, quantity: 1 },
      success: function (response) {
        console.log("Success:", response);
        window.location.href = "/checkout?express";
      },
      error: function (xhr, status, error) {
        console.error("Error:", error);
      },
    });
  }
});
jQuery(document).ready(function () {
  if (jQuery("body").hasClass("product")) {
    jQuery("#prvw__bundle_container").hide();
    var groupedQuantity = jQuery("#prvw__bundle_container").html();
    if (groupedQuantity) {
      jQuery(".product-form__buttons_new").before(
        '<div class="prvw__bundle_container">' + groupedQuantity + "</div>"
      );
    }

    jQuery(".block__cbwrapper .block__cb input#cb1").attr("checked", true);
    jQuery(".block__cbwrapper .block__cb label").on("click", function (e) {
      jQuery(".block__cbwrapper .block__cb input").removeAttr("checked");
      jQuery(this).parent().find("input").attr("checked", true);
    });

    jQuery("label.ROS-radio-button-click-target-3").on("click", function () {
      jQuery(".prvw__bundle_container").addClass("content-disabled");
    });

    function countdownByClass(className, hours, minutes, seconds) {
      var elements = document.getElementsByClassName(className);
      if (elements.length === 0) {
        console.error("Element with class '" + className + "' not found.");
        return;
      }

      var endTime, hours, mins, msLeft, time;

      function twoDigits(n) {
        return n <= 9 ? "0" + n : n;
      }

      function updateTimer() {
        msLeft = endTime - +new Date();
        if (msLeft < 1000) {
          for (var i = 0; i < elements.length; i++) {
            document.getElementById("countdown-container").style.display =
              "none";
          }
        } else {
          time = new Date(msLeft);
          hours = time.getUTCHours();
          mins = time.getUTCMinutes();
          var timeString =
            (hours ? hours + "h " + twoDigits(mins) : mins) +
            "m " +
            twoDigits(time.getUTCSeconds()) +
            "s";

          for (var i = 0; i < elements.length; i++) {
            elements[i].innerHTML = timeString;
          }

          setTimeout(updateTimer, 1000);
        }
      }

      endTime = +new Date() + 1000 * (3600 * hours + 60 * minutes + seconds);
      updateTimer();
    }

    countdownByClass("countdown", 6, 0, 0);
    const deliveryDate = new Date();
    const threeDaysLater = deliveryDate.getDate() + 3;
    deliveryDate.setDate(threeDaysLater);
    const options = { weekday: "long", month: "long", day: "numeric" };
    const formattedDate = deliveryDate.toLocaleDateString("en-US", options);
    document.querySelectorAll(".daycount").forEach((element) => {
      element.innerText = formattedDate;
    });
  }
});

// Selecting the container element
var containers = document.getElementsByTagName("variant-radios");

// Looping through all container elements (assuming there's only one)
for (var i = 0; i < containers.length; i++) {
  var container = containers[i];

  // Selecting variant labels within the container
  var variantLabels = container.querySelectorAll("label");

  // Attaching click event listeners to variant labels
  variantLabels.forEach(function (label) {
    label.addEventListener("click", function () {
      var priceContainerContent =
        this.closest("fieldset").nextElementSibling.innerHTML;
      setTimeout(function () {
        var firstPriceContainer = document.querySelector(
          "div.price__container"
        );
        var pcClassElement = document.querySelector(".pc_class");
        if (firstPriceContainer && pcClassElement) {
          pcClassElement.innerHTML = firstPriceContainer.outerHTML;
        }
        var currentURL = window.location.href;
        var url = new URL(currentURL);
        var searchParams = url.searchParams;
        var variantQueryString = searchParams.get("variant");
        var productTabsSection = document.querySelector(
          ".product-tabs__section"
        );
        if (productTabsSection) {
          var variantIdInput = productTabsSection.querySelector(
            "input.product-variant-id"
          );
          if (variantIdInput) {
            variantIdInput.value = variantQueryString;
          }
        }
      }, 2000);
    });
  });
}

function sectionSliderInit() {
  jQuery(".section--slider").each(function () {
    var $slider = jQuery(this).find(".responsive");

    // Check if the slider has already been initialized
    if (!$slider.hasClass("slick-initialized")) {
      var appendarrow = jQuery(this).find(".slider__nav");
      $slider.slick({
        dots: false,
        infinite: true,
        speed: 300,
        centerPadding: "60px",
        slidesToShow: 6,
        prevArrow:
          '<span class="slider__nav--prev slick-prev"><svg class="" aria-hidden="true" focusable="false"><use xlink:href="#prev-icon"></svg></span>',
        nextArrow:
          '<span class="slider__nav--next slick-next"><svg class="" aria-hidden="true" focusable="false"><use xlink:href="#next-icon"></svg></span>',
        appendArrows: appendarrow,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              centerPadding: "40px",
              slidesToShow: 4,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              centerPadding: "30px",
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 600,
            settings: {
              centerPadding: "16px",
              slidesToShow: 2,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      });
    }
  });

  jQuery(".collection-slider ul.product-grid").each(function () {
    var $thisSlider = $(this); // Reference to the current slider instance
    var appendarrow1 = $thisSlider.siblings(".slider-buttons");
    $thisSlider.slick({
      dots: true,
      infinite: false,
      speed: 300,
      prevArrow: '<span class="slider__nav--prev slick-prev"><svg class="" aria-hidden="true" focusable="false"><use xlink:href="#prev-icon"></svg></span>',
      nextArrow: '<span class="slider__nav--next slick-next"><svg class="" aria-hidden="true" focusable="false"><use xlink:href="#next-icon"></svg></span>',
      appendArrows: appendarrow1,
      appendDots: appendarrow1,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  });
}
sectionSliderInit();
document.addEventListener("shopify:section:select", function (event) {
  // console.log('shopify:section:select','Browse responsive');
  sectionSliderInit();
});